<template>
  <button 
    @click="$emit('click')" 
    class="edit-btn h-empty-btn h-btn"
  >
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 2.85185L9.14815 1L1.74074 8.40741L1 11L3.59259 10.2593L11 2.85185ZM7.66667 2.48148L9.51852 4.33333L7.66667 2.48148ZM1.74074 8.40741L3.59259 10.2593L1.74074 8.40741Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.edit-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: background 0.3s ease;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  &:hover {
    background: rgba($color: #fff, $alpha: 0.3);
  }
}

</style>